export const language_tr = {
  title: "Dil",
  breadcrumbTitle: "Dil",
  pageTitle: "Dil ayarı",

  language: "Dil",
};
